/**
 * Centralized features registry for the application.
 * These feature keys are checked against organization's feature flags.
 *
 * Usage:
 * - Import: import { FEATURES } from '@/access/features'
 * - Use in components: isFeatureEnabled(FEATURES.CONTACTS_TASKS)
 * - Use in router meta: feature: FEATURES.CONTACTS_TASKS
 */
export const FEATURES = Object.freeze({
  // Core Modules / main nav - deprecated, should be visible to all users
  CONTACTS: 'contacts', // Deprecated
  CAMPAIGNS: 'campaigns', // Deprecated
  LESSONS: 'lessons', // Deprecated
  CONVERSATIONS: 'conversations', // Deprecated
  AUTOMATIONS: 'automations', // Deprecated
  REPORTS: 'reports', // Deprecated
  GROUPS: 'groups', // Deprecated

  // Contact Management Features
  CONTACTS_ARCHIVED: 'contacts_archived',
  CONTACTS_BOARDS: 'contacts_boards',
  CONTACTS_NOTES: 'contacts_notes',
  CONTACTS_RELATIONSHIPS: 'contacts_relationships',
  CONTACTS_TASKS: 'contacts_tasks',

  // Conversation Features
  CONV_AUTO_CLAIM: 'conv_auto_claim',
  CONV_BLOCK_REASSIGN: 'conv_block_reassign',
  CONV_CONFIRM_CLOSING: 'conv_confirm_closing',
  CONV_FORCE_TAGGING: 'conv_force_tagging',

  // Organization & Settings
  CUSTOM_OBJECTS: 'custom_objects',
  TEAMS: 'teams',
  TAGS: 'tags',
  LINKS: 'links',
  FIELDS: 'fields',
  INTEGRATIONS: 'integrations',

  // User Management
  USERS: 'users',
  ARCHIVED_USERS: 'archived_users',
  USER_PERMISSIONS: 'user_permissions',

  // Account & Billing
  ACCOUNT: 'account',
  SETTINGS: 'settings',

  // Email Features
  EMAIL_ADDRESSES: 'email_addresses',
  EMAIL_TEMPLATES: 'email_templates',

  // Content & Tools
  TASKS: 'tasks',
  SNIPPETS: 'snippets',
  FILES: 'files',
  WORKFLOWS: 'workflows',
  FORMS: 'forms',

  // Advanced Features
  LIQUID_WIZARD: 'liquid_wizard',
  PORTAL_MESSAGING: 'portal_messaging',
  SCORM_EXPORT: 'scorm_export',
  VIDEO_HOSTING: 'video_hosting',
  SMS_PRICE: 'sms_price',

  // Security & Authentication
  OKTA_AUTH: 'okta_auth',
  REQUIRE_PUBLIC_ENCRYPTION_KEY: 'require_public_encryption_key',

  // WIDGETS
  VIDEO_UPLOAD: 'video_upload',
  SCORM: 'scorm',
  SIGNWELL: 'signwell',
  EVEREE: 'everee',
  CHECKR: 'checkr',

  // VMC
  VMC_RECRUITING: 'vmc_recruiting',
  VMC_STUDENT_DB: 'student_db',

  // AI
  CUSTOM_AGENTS: 'custom_agents',

  // Pages journey tree (home takeover + /pages routes)
  PAGES: 'pages',
  // Hidden /pages/preview route; does not take over home
  PAGES_PREVIEW: 'pages_preview',

  // Plugins
  ABTESTS: 'abtests',

  // Other
  OTHER_SETTINGS: 'other_settings',
});
